var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex justify-between space-x-2 xs:space-x-4"},_vm._l((_vm.scale),function(val){return _c('label',{key:val,staticClass:"cursor-pointer flex flex-col items-center",attrs:{"for":("smile-" + val)}},[_c('input',{staticClass:"hidden",attrs:{"type":"radio","id":("smile-" + val),"name":"smile-radio"},domProps:{"value":val,"checked":_vm.value === val},on:{"click":function($event){return _vm.$emit('change', val)}}}),_c('a-icon',{class:[
          'smile',
          'smile-' + val,
          {
            'selected': _vm.value === val,
            'colored': _vm.value === val || (_vm.type === 'smilesColorful' && !_vm.value),
          }
        ],attrs:{"component":_vm.smiles[val]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }